var _excluded = ["url", "uuid", "uid", "path"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @file 发送性能测试上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/perf
 */
import request from './util/request';
import configurable from './util/configurable';
import performance from './util/performance';
import connection from './util/connection';
import { on, off } from './util/dom';
import { trackID, userID, Config, HB_SESSION_ID_KEY } from './util/config';
import delay from './util/delay';
import cookie from './util/cookie';
/**
 * 性能上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */

var report = configurable(function (json, callback) {
  var _json$url = json.url,
      url = _json$url === void 0 ? location.href : _json$url,
      _json$uuid = json.uuid,
      uuid = _json$uuid === void 0 ? trackID : _json$uuid,
      _json$uid = json.uid,
      uid = _json$uid === void 0 ? userID : _json$uid,
      _json$path = json.path,
      path = _json$path === void 0 ? location.pathname : _json$path,
      rest = _objectWithoutProperties(json, _excluded); // 要上报的数据


  var perfData = _objectSpread({
    // 当前页面 URL
    url: url,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: uuid,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: uid,
    // 定义的当前页面路径，以区分多个页面
    path: path
  }, rest);

  request(Config.VERB)("".concat(Config.PERF), perfData, callback);
}, {});
var win = typeof window !== 'undefined' && window;
/**
 * 解除相关事件的绑定
 */

function destroy() {
  // 在 load 或 unload 时上报
  // 哪个先触发就在哪里上报，只上报一次
  off(win, 'load', observe);
  off(win, 'unload', observe);
}
/**
 * 处理事件
 *
 * @return {Undefined}
 */


function observe() {
  var timing = performance.timing;
  destroy();

  if (!timing) {
    return;
  }

  var now = +new Date();
  var connectEnd = timing.connectEnd,
      connectStart = timing.connectStart,
      domainLookupEnd = timing.domainLookupEnd,
      domainLookupStart = timing.domainLookupStart,
      domContentLoadedEventEnd = timing.domContentLoadedEventEnd,
      domComplete = timing.domComplete,
      domLoading = timing.domLoading,
      loadEventEnd = timing.loadEventEnd,
      navigationStart = timing.navigationStart,
      requestStart = timing.requestStart,
      responseStart = timing.responseStart,
      responseEnd = timing.responseEnd,
      _timing$msFirstPaint = timing.msFirstPaint,
      msFirstPaint = _timing$msFirstPaint === void 0 ? now : _timing$msFirstPaint;
  var ttfp = msFirstPaint - navigationStart;

  if (!responseEnd || !loadEventEnd || ttfp < 0) {
    return delay(observe)();
  }

  var paints = performance.getEntriesByType ? performance.getEntriesByType('paint') : [];

  if (paints.length) {
    ttfp = paints[paints.length - 1].startTime | 0;
  } else if (win.chrome && win.chrome.loadTimes) {
    var _win$chrome$loadTimes = win.chrome.loadTimes(),
        firstPaintTime = _win$chrome$loadTimes.firstPaintTime,
        startLoadTime = _win$chrome$loadTimes.startLoadTime;

    ttfp = parseInt((firstPaintTime - startLoadTime) * 1000, 10);

    if (ttfp < 0) {
      return delay(observe)();
    }
  }

  report(_objectSpread(_objectSpread({
    // DNS 解析时间
    dns: domainLookupEnd - domainLookupStart,
    // TCP 连接时间
    tcp: connectEnd - connectStart,
    // 响应时间
    resp: responseEnd - responseStart,
    // 页面可交互时间
    ready: domContentLoadedEventEnd - navigationStart,
    // DOM 树解析时间
    tree: domComplete - domLoading,
    // 接收第一个字节的时间
    ttfb: responseStart - requestStart,
    // 白屏时间
    ttsr: domLoading - navigationStart,
    // 首屏时间
    ttfp: ttfp,
    // 页面加载完成时间
    ttdc: loadEventEnd - navigationStart
  }, connection), {}, _defineProperty({
    // 请求开始发出的时间
    actionStart: requestStart,
    // action Name 页面路径
    actionName: location.origin + location.pathname,
    // 请求类型，页面加载
    reqType: 'page_load',
    // appid 项目在擎天云节点树上的标识
    appNid: Config.appNid || Config.appId || Config.APPNID
  }, HB_SESSION_ID_KEY, cookie.get(HB_SESSION_ID_KEY))));
}

on(win, 'load', observe);
on(win, 'unload', observe);
export default report;